import { Endpoints, DeviceFeatureDetection } from 'Roblox';
import angular from "angular";
import notificationStreamModule from "../notificationStreamModule";

function notificationStreamUtility(signalR, layoutLibraryService, $log) {
    "ngInject";
    var notificationSourceType = layoutLibraryService.notificationSourceType;
    var links = layoutLibraryService.links;
    var stringTemplates = layoutLibraryService.stringTemplates;

    function parseEpochMilliseconds(dateTime) {
        if (!dateTime) {
            return null;
        }

        if (dateTime.getTime) {
            // Input is a javascript Date object.
            return dateTime.getTime();
        }

        if (typeof dateTime === "string") {
            // Input is a string. Can be of serialized format "Date(123456789)", or a date string "2019-01-17T02:56:31.3146112Z".
            var serializedPattern = /Date\((\d+)\)/,
                matchResult = serializedPattern.exec(dateTime);

            if (matchResult) {
                return parseInt(matchResult[1]);
            }
            else {
                return new Date(dateTime).getTime() || null;
            }
        }

        return null;
    }

    return {
        templates: layoutLibraryService.directiveTemplatesName,
        links: links,
        textTemplate: layoutLibraryService.textTemplate,

        stringTemplates: stringTemplates,

        layout: {
            pageDataInitialized: false,
            firstTimeNotificationStream: false,
            getRecentDataInitialized: false,
            isNotificationContentOpen: false,
            isLazyLoadingRequested: false,
            isGetRecentDataLoadedRequested: true,
            notificationsScrollbarSelector: "#notification-stream-scrollbar",
            settingLink: Endpoints ? Endpoints.getAbsoluteUrl(links.settingLink) : links.settingLink,
            friendRequestLink: Endpoints ? Endpoints.getAbsoluteUrl(links.friendRequestLink) : links.friendRequestLink,
            bannerEnabled: false,
            emptyNotificationEnabled: false,
            notificationsLazyLoadingEnabled: false,
            isNotificationsLoading: false,
            isStreamBodyInteracted: false,
            bannerText: "",
            errorText: "",
            dataBindSelector: "#notification-stream",
            dataContainerSelector: "#notification-stream-container"
        },

        notificationApiParams: {
            startIndexOfNotifications: 0,
            pageSizeOfNotifications: 10,
            loadMoreNotifications: false
        },

        library: {
            unreadNotifications: 0,
            userIdList: [],
            userLibrary: {},
            prefixLocalStoragekey: "user_",
            inApp: false,
            isPhone: false,
            isTouch: DeviceFeatureDetection ? DeviceFeatureDetection.isTouch : false,
            eventStreamMetaData: {},
            gameUpdateModels: {},
            notificationContentViews: {
                main: "main",
                gameUpdates: "gameUpdates"
            },
            canLaunchGameFromGameUpdate: false
        },

        notificationsName: signalR.notifications,
        notificationSourceType: notificationSourceType,

        signalRType: signalR.types,

        friendRequestReceivedLayout: layoutLibraryService.friendRequestReceivedLayout,

        friendRequestAcceptedLayout: layoutLibraryService.friendRequestAcceptedLayout,

        friendRequestActionType: layoutLibraryService.friendRequestActionType,

        getAbsoluteUrl: function (link, params) {
            if (Endpoints) {
                return Endpoints.generateAbsoluteUrl(link, params, true);
            } else {
                return getFormatString(link, params);
            }
        },

        getFormatString: function (link, params) {
            for (var prop in params) {
                var value = params[prop];
                var regex = new RegExp("{" + prop.toLowerCase() + "(:.*?)?\\??}");
                link = link.replace(regex, value);
            }
            return link;
        },

        isNotificationTypeValid: function (notificationType) {
            var isMatch = false;
            for (var type in notificationSourceType) {
                if (notificationSourceType[type] === notificationType) {
                    isMatch = true;
                    break;
                }
            }
            return isMatch;
        },

        isCardClickable: function (notification) {
            var notificationType = notification.notificationSourceType;
            switch (notificationType) {
                case notificationSourceType.friendRequestAccepted:
                    return notification.eventCount > 1 || (notification.eventCount === 1 && notification.metadataCollection.length === 0);
                case notificationSourceType.privateMessageReceived:
                case notificationSourceType.developerMetricsAvailable:
                    return true;
            }
            return false;
        },

        normalizeUser: function (notificationType, userData) {
            var user = {
                userId: null,
                userName: null
            };
            switch (notificationType) {
                case notificationSourceType.friendRequestReceived:
                    user.userId = userData.SenderUserId;
                    user.userName = userData.SenderUserName;
                    break;
                case notificationSourceType.friendRequestAccepted:
                    user.userId = userData.AccepterUserId;
                    user.userName = userData.AccepterUserName;
                    break;
                case notificationSourceType.privateMessageReceived:
                    user.userId = userData.AuthorUserId;
                    user.userName = userData.AuthorUserName;
                    break;
                case notificationSourceType.developerMetricsAvailable:
                case notificationSourceType.test:
                    break;
            }
            return user;
        },

        getUserHtmlTemplate: function (notificationType, count) {
            var htmlTemplate = "";
            switch (notificationType) {
                case notificationSourceType.friendRequestAccepted:
                    if (count > 1) {
                        htmlTemplate = stringTemplates.boldLink;
                    } else {
                        htmlTemplate = stringTemplates.userLink;
                    }
                    break;

                case notificationSourceType.friendRequestReceived:
                default:
                    htmlTemplate = stringTemplates.userLink;
                    break;
            }
            return htmlTemplate;
        },

        normalizeYouHaveText: function (notificationType, requestCount) {
            switch (notificationType) {
                case notificationSourceType.friendRequestReceived:
                    return layoutLibraryService.newFriendRequests(requestCount);
                case notificationSourceType.friendRequestAccepted:
                    return layoutLibraryService.newFriends(requestCount);
            }
            return {};
        },

        normalizeSingleDisplayText: function (notificationType, userOne) {
            switch (notificationType) {
                case notificationSourceType.friendRequestReceived:
                    return layoutLibraryService.friendRequestSentSingle(userOne);
                case notificationSourceType.friendRequestAccepted:
                    return layoutLibraryService.friendRequestAcceptedSingle(userOne);
            }
            return {};
        },

        normalizeSingleConfirmedText: function (notificationType, userOne) {
            switch (notificationType) {
                case notificationSourceType.friendRequestReceived:
                    return layoutLibraryService.confirmSentSingle(userOne);
                case notificationSourceType.friendRequestAccepted:
                    return layoutLibraryService.confirmAcceptedSingle(userOne);
            }
            return {};
        },

        normalizeDoubleDisplayText: function (notificationType, userOne, userTwo) {
            switch (notificationType) {
                case notificationSourceType.friendRequestReceived:
                    return layoutLibraryService.friendRequestSentDouble(userOne, userTwo);
                case notificationSourceType.friendRequestAccepted:
                    return layoutLibraryService.friendRequestAcceptedDouble(userOne, userTwo);
            }
            return {};
        },

        normalizeDoubleConfirmedText: function (notificationType, userOne, userTwo) {
            switch (notificationType) {
                case notificationSourceType.friendRequestReceived:
                    return layoutLibraryService.confirmSentDouble(userOne, userTwo);
                case notificationSourceType.friendRequestAccepted:
                    return layoutLibraryService.confirmAcceptedDouble(userOne, userTwo);
            }
            return {};
        },

        normalizeMultipleDisplayText: function (notificationType, userOne, userTwo, userMultipleCount) {
            switch (notificationType) {
                case notificationSourceType.friendRequestReceived:
                    return layoutLibraryService.friendRequestSentMultiple(userOne, userTwo, userMultipleCount);
                case notificationSourceType.friendRequestAccepted:
                    return layoutLibraryService.friendRequestAcceptedMultiple(userOne, userTwo, userMultipleCount);
            }
            return {};
        },

        normalizeMultipleConfirmedText: function (notificationType, userOne, userTwo, userMultipleCount) {
            switch (notificationType) {
                case notificationSourceType.friendRequestReceived:
                    return layoutLibraryService.confirmSentMultiple(userOne, userTwo, userMultipleCount);
                case notificationSourceType.friendRequestAccepted:
                    return layoutLibraryService.confirmAcceptedMultiple(userOne, userTwo, userMultipleCount);
            }
            return {};
        },

        normalizeSelfMaxFriendsErrorText: function () {
            return layoutLibraryService.tooManyFriendsSelf();
        },

        normalizeOtherMaxFriendsErrorText: function () {
            return layoutLibraryService.tooManyFriendsOther();
        },

        buildScrollbar: function (className) {
            var scrollbarElm = angular.element(className);
            scrollbarElm.mCustomScrollbar({
                autoHideScrollbar: false,
                autoExpandScrollbar: false,
                contentTouchScroll: 10000,
                documentTouchScroll: false,
                mouseWheel: {
                    preventDefault: true
                },
                advanced: {
                    autoScrollOnFocus: false
                }
            });
        },

        isGameUpdateNotification: function (notificationType) {
            return notificationType === notificationSourceType.gameUpdate;
        },

        parseEpochMilliseconds: parseEpochMilliseconds,

        sortNotificationsByEventDate: function (notifications, isAscending) {
            if (!notifications) {
                return null;
            }

            var notificationArray = Object.keys(notifications).map(function (k) {
                return notifications[k];
            });

            notificationArray.sort(function (n1, n2) {
                var epoch1 = parseEpochMilliseconds(n1.eventDate) || 0,
                    epoch2 = parseEpochMilliseconds(n2.eventDate) || 0;

                return isAscending ? epoch1 - epoch2 : epoch2 - epoch1;
            });

            return notificationArray;
        }
    };
}

notificationStreamModule.factory("notificationStreamUtility", notificationStreamUtility);

export default notificationStreamUtility;